/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 15.10.24
 *
 */
import BaseCookie from "@/core/js/Cookie/BaseCookie";

export default class Base64Cookie extends BaseCookie {

	constructor() {
		super(null);
	}

	set(key, value){
		super.set(value, key)
	}
	setOnce(key, value){
		super.setOnce(value, key)
	}
	save(key, value){
		super.save(value, key)
	}

	onBeforeSet(value){
		return btoa(super.onBeforeSet(value))
	}

	onAfterGet(value){
		return super.onAfterGet(atob(value))
	}
}
